window.Products.Stationery.PermanentSticker = function () {}
window.Products.Stationery.PermanentSticker.inherits(window.Products.Stationery.Stationery)
